/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunViolationRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunViolationRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunViolationRequest>): WellArchitectedFrameworkAssessmentRunViolationRequest {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunViolationRequest(), model);
        WellArchitectedFrameworkAssessmentRunViolationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunViolationRequest>): WellArchitectedFrameworkAssessmentRunViolationRequest {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunViolationRequest.newInstance(<WellArchitectedFrameworkAssessmentRunViolationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunViolationRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunViolationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunViolationRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunViolationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Identity of the Policy Job
     */
    policy_job_id: string;

}
